import { Skeleton } from '@mui/material/';
import { useSelector } from 'react-redux';
import {  Grid, Box } from '@mui/material';
const SidebarSkeleton = () => {
    var SiteData = useSelector(state => state.SiteData);
    const skNoItems = SiteData.storesperload ? SiteData.storesperload : 10;
    const style = ('right' === SiteData.sidebarposition) ? {marginLeft:'5px', marginBottom:'5px', marginTop:'5px'} : {marginBottom:'5px', marginTop:'5px'};
    const mdSize = ('bottom-list' === SiteData.sidebarposition || 'bottom-grid' === SiteData.sidebarposition) ? 12 : 4;
    const skItems = [];
    for (var i = 0; i < skNoItems; i++ ) {
        skItems.push(
            ('bottom-list' === SiteData.sidebarposition || 'bottom-grid' === SiteData.sidebarposition) ?
                <Grid container style={style} key={i}>
                    {(!SiteData.enableAccordion) ?
                    <><Grid item xs={12} md={10}>
                        <Skeleton className="text" variant="text" width={900} />
                        <Skeleton className="text" variant="text" width={800} />
                        <Skeleton className="text" variant="text" width={840} />
                        <Skeleton className="text" variant="text" width={640} />
                        <Skeleton className="text" variant="text" width={800} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Skeleton className="icon" style={{marginRight:'5px'}} variant="rectangular" width={150} height={150} />
                    </Grid></>
                    :
                    <Grid item xs={12} md={8}>
                        <Skeleton className="text" variant="text" width={1200} height={50} />
                    </Grid>
                    }
                </Grid>
            :
            <Grid container style={style} key={i}>
                    {(!SiteData.enableAccordion) ?
                    <><Grid item xs={12} md={8}>
                        <Skeleton className="text" variant="text" width={300} />
                        <Skeleton className="text" variant="text" width={200} />
                        <Skeleton className="text" variant="text" width={240} />
                        <Skeleton className="text" variant="text" width={240} />
                        <Skeleton className="text" variant="text" width={200} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Skeleton className="icon" style={{marginRight:'5px'}} variant="rectangular" width={100} height={100} />
                    </Grid></>
                    :
                    <Grid item xs={12} md={8}>
                        <Skeleton className="text" variant="text" width={400} height={80} />
                    </Grid>
                    }
            </Grid>
        )
      }
    return(
        ('hide' !== SiteData.sidebarposition) ? <Grid item xs={12} md={mdSize}>
            {skItems}
        </Grid> : ''
    )
}
export default SidebarSkeleton